export const KPICard = ({ label, value, trend, subtitle, type = 'default', icon: Icon }) => {
  const typeStyles = {
    default: 'border-slate-200',
    success: 'border-l-4 border-l-emerald-500',
    warning: 'border-l-4 border-l-amber-500',
    urgent: 'border-l-4 border-l-red-500',
  };

  return (
    <div className={`kpi-card ${typeStyles[type]}`} data-testid={`kpi-${label.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-start justify-between">
        <div>
          <p className="kpi-value">{value}</p>
          <p className="kpi-label">{label}</p>
        </div>
        {Icon && (
          <div className={`p-2 ${
            type === 'success' ? 'bg-emerald-100 text-emerald-600' :
            type === 'warning' ? 'bg-amber-100 text-amber-600' :
            type === 'urgent' ? 'bg-red-100 text-red-600' :
            'bg-slate-100 text-slate-600'
          }`}>
            <Icon size={24} />
          </div>
        )}
      </div>
      {subtitle && (
        <p className="text-xs mt-2 text-emerald-600 font-medium" data-testid={`kpi-subtitle-${label.toLowerCase().replace(/\s+/g, '-')}`}>
          {subtitle}
        </p>
      )}
      {trend && (
        <p className={`text-xs mt-2 ${trend > 0 ? 'text-red-500' : 'text-emerald-500'}`}>
          {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}% from yesterday
        </p>
      )}
    </div>
  );
};
